import { render, staticRenderFns } from "./FormulareManuale.vue?vue&type=template&id=ec82e4a4&scoped=true"
import script from "./FormulareManuale.vue?vue&type=script&lang=js"
export * from "./FormulareManuale.vue?vue&type=script&lang=js"
import style0 from "./FormulareManuale.vue?vue&type=style&index=0&id=ec82e4a4&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ec82e4a4",
  null
  
)

export default component.exports